import cssVars from 'css-vars-ponyfill'

cssVars({watch: true})
